import { RouteType } from '@/main/menu/constants';

import { NAME } from './CustomerLeads/constants';
import { HromadnaKorespondence } from './hromadnaKorespondence';
import { Zpravy } from './zpravy';
import { DanVerification } from './DanVerification';
import { VerificationHistory } from './VerificationHistory';
import { CustomerVerification } from './CustomerVerification';
import { DialogueMarketing } from '../ciselnik/DialogueMarketing';
import { EventConfiguration } from '../ciselnik/DialogueMarketing/eventconfiguration';
import { CommunicationEventConfiguration } from '../ciselnik/DialogueMarketing/CommunicationEventConfiguration';
import { EventFrequency } from '../ciselnik/DialogueMarketing/eventfrequency';

export const menu = {
	name: 'CRM_Aktivity',
	list: [
		{ name: 'CRM_Kontakty', route: 'ZakaznikKontakt' },
		{ name: 'CRM_Leady', route: 'Leady' },
		{ name: 'CRM_ObchPripady', route: 'ObchPrip' },
		{ name: 'CRM_Kampane', route: 'Kampane' },
		{ name: 'HromKoresp', route: HromadnaKorespondence.name },
		{ name: 'Zpravy', route: Zpravy.name },
		{ name: 'Customer_Leads', route: NAME },
		{ name: 'CX', route: '/ccms/CX/Events/List', routeType: RouteType.url },
		{ name: 'CCMS', route: '/ccms', routeType: RouteType.url },
		{
			name: 'DanVerification',
			list: [
				{ name: 'DanVerification', route: DanVerification.name },
				{ name: 'VerificationHistory', route: VerificationHistory.name },
				{ name: 'CustomerVerification', route: CustomerVerification.name },
			],
		},
		{
			name: 'DialogueMarketing',
			route: DialogueMarketing.name,
			list: [
				{ name: 'EventConfiguration', route: EventConfiguration.name },
				{ name: 'EventFrequency', route: EventFrequency.name },
				{ name: 'CommunicationEventConfig', route: CommunicationEventConfiguration.name },
			],
		},
	],
};
